import * as types from "./types";

import { 
    postAttendanceAxios,
    getAttendanceListAxios,
    putAttendanceAxios,
    getAttendanceByIDAxios,
    postImportAttendanceAxios

} from "./services";

export async function getAttendanceListAction({commit}, {id, date, currentEmployee = false}) {
    commit(types.LOADING_ATTENDANCE, true);
    try {
        const {data} = await getAttendanceListAxios({id, date, currentEmployee});
        commit(types.GET_ATTENDANCE_LIST, data.result.data);
        
        return data;
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    commit(types.LOADING_ATTENDANCE, false);
}

export async function addAttendanceAction({commit}, payload) {
    commit(types.LOADING_ATTENDANCE, true);
    try {
        const {data} = await postAttendanceAxios(payload);
        payload.id = data.result.id;
        commit(types.ADD_ATTENDANCE, payload);
        return data;
    }
    catch(e) {
        console.log(e);
        throw e;
    }
    finally {
        commit(types.LOADING_ATTENDANCE, false);
    }
}

export async function updateAttendanceAction({commit}, payload) {
    commit(types.LOADING_ATTENDANCE, true);
    try {
        const { data } = await putAttendanceAxios(payload);        
        commit(types.UPDATE_ATTENDANCE, payload);
        return data;
    }
    catch(e) {
        throw e;
    }
    finally{
        commit(types.LOADING_ATTENDANCE, false);
    }
}

export async function getAttendanceByIDAction({commit}, payload) {
    commit(types.LOADING_ATTENDANCE, true);
    try {
        const {data} = await getAttendanceByIDAxios(payload);
        commit(types.GET_ATTENDANCE_BYID, data.result);
    }
    catch(e) {
        console.log(e);
    }
    commit(types.LOADING_ATTENDANCE, false);
}

export async function importAttendanceAction({ commit }, payload) {
  commit(types.LOADING_ATTENDANCE, true);
  try {
    const { data } = await postImportAttendanceAxios(payload);
    (payload);
    commit(types.IMPORT_ATTENDANCE, payload);
    return data;
  }
  catch (e) {
    throw e;
  }
  finally {
    commit(types.LOADING_ATTENDANCE, false);
  }
}